import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {AccountSummary} from '../../../../../../shared/model/account/accountSummary.model';

export class FormDefinitionFormSummaryModel extends WithPermissionModel {
    id: number;
    label: string;
    name: string;
    context: LovValueSummary;
    active: boolean;
    account: AccountSummary;
    cloneable: boolean;
}
